import React from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";
import {saveSubentry} from './SubentryActions';
import './Subentries.css';
import {getLexemeProperties, getLexemeOptions} from './../../LexemePage';
import {
    CgrTypeahead,
    EntryTypeahead,
    LexemeNavigator,
    SCCheckbox,
    SCSubmitButton
} from './../../../../dict-components/components';
import Dict from 'dict-lib';
import {Grid, Row, Col, InputGroup, FormControl, Button, Label} from 'react-bootstrap';
import {SCRadiobutton} from '../../../../dict-components/components';
import './../../../../_css/lexeme.css';
import {LexemeEditingLevel, LexemeUtilities} from "../LexemeHelper";
import stylesLexemeSubentries from "../../../../_css/dictionary/lexemeParts/lexemeSubentries.module.css";
import BUtils from './../../../../utilities/BaseUtilities';
import ButtonGroup from "react-bootstrap/es/ButtonGroup";
import {Notifications} from "../../../../utilities/DictUtilities";
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";
import {TreeNodeHelper} from "../../../../dict-components/tree/components/TreeHelper";
import {Typeahead} from "react-bootstrap-typeahead";
import stylesMorphoRule from "../../../../_css/dictionary/lexemeParts/lexemeMorphoRule.module.css";

export class SubForms extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            forms: [],
            availableCgrs: [],
            item: this.props.item,
            chunks: [],
            doNotDecline: false,
            rulePath: '',
            editingForm: {},
            mode: 'grid',
            showAskRemoveForm: false
        };
    }

    componentWillMount() {
        var columns = this.state.mode === 'grid' ? 3 : 1;
        Dict.call('/subentries/retrieveForms/' + this.props.item.ids + '/').then((result) => {
            this.setState({forms: result.forms}, () => {
                this._resetChunks(columns);
                const doNotDecline = result.doNotDecline;
                const rulePath = Dict.t('APPLIED_RULE') + ':&nbsp;<strong>' + (typeof result.rulePath !== 'undefined' ? result.rulePath : Dict.t('NONE_F')) + '</strong>';
                this.setState({doNotDecline, rulePath});
            });
        });
    }

    _resetChunks(columns) {
        const length = this.state.forms.length;
        var chunkSize = Math.round(length / columns);
        var chunks = [];
        for (let i = 0; i < length; i += chunkSize) {
            const chunk = this.state.forms.slice(i, i + chunkSize);
            chunks.push(chunk);
        }

        this.setState({chunks});
    }

    _handleSubentryForm(evt, id_form, chunkNumber) {
        var chunks = this.state.chunks;
        var formItem = chunks[chunkNumber].find((item) => {
            return item.id_form === id_form;
        });

        formItem.form = evt.target.value;

        this.setState({chunks});
    }

    _changeMode() {
        var mode = this.state.mode === 'grid' ? 'advanced_editing' : 'grid';
        var columns = mode === 'grid' ? 3 : 1;
        this.setState({mode, editingForm: {}}, () => {
            this._resetChunks(columns);
        });
    }

    _prepareSaveAll() {
        Notifications.showModalSpinner(Dict.t('OPERATION_IN_PROFRESS'), '');
        var saveChunk = [];
        this.state.chunks.forEach((partChunk) => {
            saveChunk = saveChunk.concat(partChunk.map((rowChunk) => {
                return {id: rowChunk.id_form, form: rowChunk.form};
            }));
        });

        var saveChunks = this._sliceIntoSaveChunks(saveChunk, 10);
        this._saveAll(0, saveChunks);
    }

    _sliceIntoSaveChunks(arr, chunkSize) {
        const res = [];

        var i = 0;
        while (i < arr.length) {
            var realChunkSize = (i + chunkSize) > arr.length ? arr.length - i : chunkSize;
            const chunk = arr.slice(i, i + realChunkSize);
            res.push(chunk);
            i = i + realChunkSize;
        }


        return res;
    }

    _saveAll(indexChunk, saveChunks) {
        var encodedChunks = LexemeUtilities.encodeUrl(JSON.stringify(saveChunks[indexChunk]));
        Dict.call('/subentries/saveForms/' + this.props.item.ids + '/' + encodedChunks + '/' + this.state.doNotDecline + '/').then((result) => {
            if (result === 'OK') {
                if (indexChunk === (saveChunks.length - 1)) {
                    Notifications.closeModalSpinner();
                } else {
                    this._saveAll(++indexChunk, saveChunks);
                }
            } else {
                Notifications.showErrorModalMessage("Errore nel salvataggio delle forme", 2000);
            }
        })
    }

    _openEditByForm(rowChunk) {
        Dict.call('subentries/getForm/' + rowChunk.id_form + '/').then((editingForm) => {
            this.setState({editingForm, showAskRemoveForm: false, originalEditingForm: BUtils.cloneJson(editingForm)});/*, () => {
                var openEditingForm = this._openEdit();
                ReactDOM.render(openEditingForm, document.getElementById('sub-forms-editing-col'));
            });*/
        })
    }

    _openEdit() {
        var editingForm = this.state.editingForm;
        var originalEditingForm = this.state.originalEditingForm;
        const hasSuggestedForm = typeof originalEditingForm !== 'undefined' && typeof originalEditingForm.suggestedForm !== 'undefined' && originalEditingForm.suggestedForm !== null;
        const changeSuggestionForm = typeof editingForm.changeSuggestionForm !== 'undefined' && editingForm.changeSuggestionForm === true;
        const isNew = parseInt(editingForm.id) < 0;

        return !_.isEmpty(editingForm) ? <>
            <div className={stylesLexemeSubentries['subentry-forms-edit-row__elements']}>
                {isNew ? <>
                    <div
                        className={stylesLexemeSubentries['subentry-forms-edit-row__new-form']}>{Dict.t('NEW_FORM')}</div>
                    <div className={stylesLexemeSubentries['subentry-forms-edit-row__new-form-cgr-typeahead']}>
                        <Typeahead
                            id={'cgr-th'}
                            ref={"cgr_forms_typeahead"}
                            multiple={false}
                            clearButton
                            onChange={(item) => {
                                editingForm.cgr = item.length > 0 ? item[0] : [];
                                this.setState({editingForm});
                                document.getElementsByClassName(stylesLexemeSubentries['subentry-forms-edit-row__input'])[0].focus();
                            }}
                            options={this.state.availableCgrs}
                            placeholder={Dict.t('CHOOSE_CGR')}
                            selected={typeof editingForm.cgr !== 'undefined' ? LexemeUtilities.getTypeaheadItem(this.state.availableCgrs, editingForm.cgr) : []}
                        />
                    </div>
                </> : ''}
                <InputGroup className={stylesLexemeSubentries['subentry-forms-edit-row__input-group']}>
                    <InputGroup.Addon
                        className={stylesLexemeSubentries['subentry-forms-edit-row__input-label']}>{Dict.t('FORM')}</InputGroup.Addon>
                    <FormControl type='text' placeholder={Dict.t('FORMS') + "..."}
                                 className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-edit-row__input'])}
                                 ref={(input) => {
                                     this.subentryEditForm = input;
                                 }}
                                 value={editingForm.form}
                                 onChange={(evt) => {
                                     var newEditingForm = this.state.editingForm;
                                     newEditingForm.form = evt.target.value;
                                     this.setState({editingForm: newEditingForm});
                                 }}
                    />
                </InputGroup>
                {/*<Label>{editingForm.entryAbstr}</Label>*/}
                <SCRadiobutton default={editingForm.errorLevel + ''}
                               label={Dict.t('ERROR_LEVEL')}
                               i18nLabel={true}
                               additionalClass={stylesLexemeSubentries['subentry-forms-edit-row__radio']}
                               items={[{code: '0', label: 'CORRECT_FORM'}, {
                                   code: '1',
                                   label: 'NOT_RECOMMENDED_FORM'
                               }, {code: '2', label: 'WRONG_FORM'}]}
                               bsStyle="default"
                               callbackParent={(newState) => {
                                   editingForm.errorLevel = newState;
                                   this.setState({editingForm});
                               }}
                />
                <InputGroup className={stylesLexemeSubentries['subentry-forms-edit-row__input-group']}>
                    <InputGroup.Addon
                        className={stylesLexemeSubentries['subentry-forms-edit-row__input-label']}>{Dict.t('FREQUENCY')}</InputGroup.Addon>
                    <FormControl type='number' placeholder={Dict.t('FREQUENCY') + "..."}
                                 label={Dict.t('FREQUENCY')}
                                 className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-edit-row__number-input'])}
                                 ref={(input) => {
                                     this.subentryEditForm = input;
                                 }}
                                 value={editingForm.frequency}
                                 onChange={(evt) => {

                                     editingForm.frequency = evt.target.value;
                                     this.setState({editingForm});
                                 }}
                    />
                </InputGroup>
                <div
                    className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-edit-row__typeahead'], stylesLexemeSubentries['subentry-forms-edit-row__typeahead__change--' + changeSuggestionForm])}>
                    <div
                        className={stylesLexemeSubentries['subentry-forms-edit-row__typeahead-label']}>{Dict.t('SUGGESTED_FORM')}</div>
                    {changeSuggestionForm ?
                        <><EntryTypeahead languageId={this.props.context.languageId} onFocus={this._handleOnFocus}
                                          classType={'DeclinedForm'}
                                          fieldIdName={'idForm'}
                                          autoFocus={false}
                                          callbackParent={(suggestedForm) => {
                                              editingForm.suggestedForm = suggestedForm;
                                              this.setState({editingForm});
                                          }
                                          }/>
                            <div className={stylesLexemeSubentries['subentry-forms-edit-row__typeahead-button']}
                                 onClick={() => {
                                     editingForm.changeSuggestionForm = false;
                                     editingForm.suggestedForm = BUtils.cloneJson(originalEditingForm.suggestedForm);
                                     this.setState({editingForm});
                                 }
                                 }>reset
                            </div>
                        </> : ''}
                    {hasSuggestedForm ?
                        <div className={stylesLexemeSubentries['subentry-forms-edit-row__typeahead-suggestedForm']}>[
                            <span
                                className={stylesLexemeSubentries['subentry-forms-edit-row__typeahead-suggestedForm__entry']}>{originalEditingForm.suggestedForm.entryForm}</span>
                            <span
                                className={stylesLexemeSubentries['subentry-forms-edit-row__typeahead-suggestedForm__declined']}>{' - ' + originalEditingForm.suggestedForm.declinedForm + ' - ' + originalEditingForm.suggestedForm.abstr}</span>
                            ]</div> : ''}
                    {hasSuggestedForm && !changeSuggestionForm ? <>
                        <div className={stylesLexemeSubentries['subentry-forms-edit-row__typeahead-button']}
                             onClick={() => {
                                 editingForm.changeSuggestionForm = true;
                                 editingForm.suggestedForm = '';
                                 this.setState({editingForm});
                             }
                             }>{Dict.t('CHANGE_REMOVE')}</div>
                    </> : ''}
                    {!hasSuggestedForm && !changeSuggestionForm ? <>
                        <div className={stylesLexemeSubentries['subentry-forms-edit-row__typeahead-button']}
                             onClick={() => {
                                 editingForm.changeSuggestionForm = true;
                                 this.setState({editingForm});
                             }
                             }>{Dict.t('ADD')}</div>
                    </> : ''}
                </div>
                {editingForm.asSuggestedForm.length > 0 ? <div className={stylesLexemeSubentries['subentry-forms-edit-row__asSuggestedForm']}>
                    <div className={stylesLexemeSubentries['subentry-forms-edit-row__asSuggestedFormLabel']}>{Dict.t('IS_SUGGESTED_FORM_OF')}:</div>
                    <div className={stylesLexemeSubentries['subentry-forms-edit-row__asSuggestedFormList']}>{editingForm.asSuggestedForm.map((item, index) => {
                        return item + (index < editingForm.asSuggestedForm.length - 1 ? ', ' : '');
                    })}</div>
                </div> : ''}
            </div>
            <div className={stylesLexemeSubentries['subentry-forms-edit-row__buttons']}>
                <div
                    className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-edit-row__buttons-ask-container'], stylesLexemeSubentries['subentry-forms-edit-row__buttons-ask-container--' + this.state.showAskRemoveForm])}>
                    <div
                        className={stylesLexemeSubentries['subentry-forms-edit-row__buttons-ask']}>{Dict.t('ASK_REMOVE_FORM')}</div>
                    <Button id='bt-edit-delete-form' onClick={() => {
                        Dict.call('/subentries/deleteForm/' + editingForm.id + '/').then((result) => {
                            if(result.result === 'OK') {
                                document.getElementById('').classList.add('btn-warning');
                                this._saveDeleteResult('bt-edit-delete-form', result, true);
                                var editingForm = {};
                                this.setState({editingForm});
                            } else {
                                Notifications.showErrorModalMessage('FOUND_AS_SUGGESTED_FORM', 2000)
                            }
                        })
                    }}
                    >{Dict.t('YES')}</Button>
                    <Button onClick={() => {
                        this.setState({showAskRemoveForm: false})
                    }}>{Dict.t('NO')}</Button>
                </div>
                {!isNew ? <Button onClick={() => {
                    this.setState({showAskRemoveForm: !this.state.showAskRemoveForm})
                }}>{Dict.t('REMOVE')}</Button> : ''}
                <Button id='bt-edit-save-form' onClick={() => {
                    if (isNew && (typeof editingForm.cgr === 'undefined' || editingForm.cgr === '') || editingForm.form === '') {
                        Notifications.showErrorModalMessage('CGR_OR_FORM_MISSING', 2000)
                    } else {
                        if (isNew)
                            editingForm.ids_subentry = this.state.item.ids;

                        var saveEle = document.getElementById('bt-edit-save-form');
                        saveEle.classList.add('btn-warning');
                        Dict.call('/subentries/saveForm/' + LexemeUtilities.encodeUrl(JSON.stringify(editingForm)) + '/').then((result) => {
                            if (isNew) {
                                editingForm.id = result.newId;
                            }

                            this.setState({editingForm}, () => {
                                this._saveDeleteResult('bt-edit-save-form', result, false);
                            });
                        })
                    }
                }}>{Dict.t('SAVE')}</Button></div>
        </> : '';
    }

    _saveDeleteResult(idEle, result, isDelete) {
        var ele = document.getElementById(idEle);
        ele.classList.remove('btn-warning');

        var addClass;
        if (result.result === 'OK') {
            addClass = 'btn-success';
            this.setState({forms: result.forms}, () => {
                if (isDelete) {
                    this.setState({editingForm: {}, showAskRemoveForm: false});
                } else {
                    this._openEditByForm({id_form: this.state.editingForm.id});
                }
                this._resetChunks(1);
            });
        } else {
            addClass = 'btn-danger';
        }

        ele.classList.add(addClass);

        setTimeout(() => {
            ele.classList.remove(addClass);
        }, 1000);
    }

    _empty() {
        var chunks = JSON.parse(JSON.stringify(this.state.chunks));
        this.state.chunks.forEach((partChunk, indexChunk) => {
            partChunk.forEach((itemPartChunk, indecPartChunk) => {
                var obj = chunks[indexChunk][indecPartChunk];
                obj.form = '';
                obj.form_for_searching = ';'
            })
        });

        this.setState({chunks});
    }

    render() {
        var isGridMode = this.state.mode === 'grid';


        var chunks = this.state.chunks.map((chunk, index) => {
            var perc = isGridMode ? parseInt((100 / this.state.chunks.length) * (12 / 100)) : 4;
            var rowChunks = chunk.map((rowChunk) => {
                return <Row id={'subentry-forms-row--' + rowChunk.id_form}
                            className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-row'], stylesLexemeSubentries['subentry-forms-row-grid--' + isGridMode], stylesLexemeSubentries['subentry-forms-row--' + (!isGridMode && rowChunk.id_form === this.state.editingForm.id)])}
                            onClick={() => {
                                if (!isGridMode) {
                                    this._openEditByForm(rowChunk);
                                }
                            }
                            }
                >
                    <div
                        className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-row__cgr'], stylesLexemeSubentries['subentry-forms-row__cgr-grid--' + isGridMode])}
                    >
                        <span>{rowChunk.cgr}</span>
                    </div>
                    <div
                        className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-row__form'], stylesLexemeSubentries['subentry-forms-row__form-grid--' + isGridMode])}>
                        {isGridMode ? <FormControl type="text" placeholder={Dict.t('FORMS') + "..."}
                                                   className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms-row__input'])}
                                                   ref={(input) => {
                                                       this.subentryForm = input;
                                                   }}
                                                   value={rowChunk.form}
                                                   onChange={(evt) => this._handleSubentryForm(evt, rowChunk.id_form, index)}
                                                   on
                                                   onKeyUp={(evt) => {
                                                       LexemeUtilities.handleKeyUp(evt, () => {
                                                           var ele = document.getElementById('subentry-forms-row--' + rowChunk.id_form);
                                                           var changeObj = [{
                                                               id: rowChunk.id_form,
                                                               form: rowChunk.form
                                                           }];
                                                           ele.style.outlineColor = '#f89700';
                                                           Dict.call('/subentries/saveForms/' + this.props.item.ids + '/' + LexemeUtilities.encodeUrl(JSON.stringify(changeObj)) + '/' + this.state.doNotDecline + '/').then((result) => {
                                                               if (result === 'OK') {
                                                                   ele.style.outlineColor = '#00833d';
                                                                   setTimeout(function () {
                                                                       ele.style.outlineColor = '#989898';
                                                                   }, 500);
                                                               } else {
                                                                   ele.style.outlineColor = '#a50400';
                                                               }
                                                           })
                                                       })
                                                   }}
                        /> : <div className={stylesLexemeSubentries['subentry-forms-row__edit']}>{rowChunk.form}</div>}
                    </div>
                </Row>;
            });

            return <Col lg={perc} md={perc}
                        className={stylesLexemeSubentries['sub-forms-editing-col-list--' + isGridMode]}>{rowChunks}</Col>;
        });

        var colEditing = '';
        if (!isGridMode) {
            colEditing = <Col id={'sub-forms-editing-col'} lg={8} md={8}>{this._openEdit()}</Col>;
        }

        return <>
            <div style={{
                height: '30px',
                border: '1px solid #dcdcdc',
                borderRadius: '3px',
                paddingTop: '4px',
                marginBottom: '6px'
            }} dangerouslySetInnerHTML={{__html: this.state.rulePath}}/>
            <div id='subentry-forms'
                 className={BUtils.joinClasses(stylesLexemeSubentries['subentry-forms'], stylesLexemeSubentries['subentry-forms-grid-mode--' + isGridMode])}>
                <Grid fluid>
                    {chunks}
                    {colEditing}
                </Grid>
            </div>
            <div className={stylesLexemeSubentries['subentry-forms-button-bar']}>
                {isGridMode ?
                    <>
                        <div style={{display: 'inline-block', marginRight: '20px'}}>
                            <SCCheckbox id={'chk-do-not-decline-forms'} checked={this.state.doNotDecline}
                                        label={Dict.t('DO_NOT_DECLINE_FORMS')}
                                        callbackParent={(id, doNotDecline) => {
                                            this.setState({doNotDecline});
                                        }}/>
                        </div>
                        <Button onClick={() => this._empty()}>{Dict.t('EMPTY')}</Button></> :
                    <Button onClick={() => {
                        Dict.call('/subentries/getAvailableCategoriesBySubentry/' + this.props.item.ids + '/').then((result) => {
                            this.setState({availableCgrs: result.items}, () => {
                                this._openEditByForm({id_form: -1});
                            });
                        });
                    }
                    }>{Dict.t('ADD')}</Button>}
                <Button style={{width: '200px'}}
                        onClick={() => this._changeMode()}>{'passa a ' + Dict.t(this.state.mode === 'grid' ? 'ADVANCED_EDITING_MODE' : 'GRID_MODE')}</Button>
                <Button style={{width: '200px'}}
                        onClick={() => this._openTemplate()}>{'passa al template'}</Button>
                {isGridMode ? <Button onClick={() => this._prepareSaveAll()}>{Dict.t('SAVE')}</Button> : ''}
            </div>
        </>;
    }

}